import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Img from "../../Assets/img/thankyou.png";
import Header from "../../Components/MainLayout/Header/index";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class ThankYou extends Component {
  render() {
    console.log(this);
    let orderId = window.location.href?.split("order_id=")[1]?.split("&")[0];
    let amount = window.location.href?.split("amount=")[1]?.split("&")[0];
    let schName = window.location.href?.split("school=")[1]?.split("&")[0];
    return (
      <React.Fragment>
        <Header title="Home" />
        <div className="container">
          <div className={`text-center h-100 ${orderId ? "mt-5" : ""}`}>
            <div
              className="py-3"
              style={{
                backgroundImage: `url(${Img})`,
                height: 350,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            ></div>
            {orderId ? (
              <p className="th-12 th-black mb-0">Order Id: {orderId}</p>
            ) : null}

            {amount ? (
              <p className="th-12 th-black mb-2">Amount: {amount}</p>
            ) : null}
            <h6>Payment Successful!</h6>
            <p className="th-12 th-grey mb-0">
              The payment has successfully been sent to
            </p>
            <p className="th-12 th-black th-bold">
              {schName
                ? decodeURI(schName)
                : this.props?.user?.user?.school?.school_name}
              .
            </p>

            <div className="pb-5">
              <Link className="text-success th-14" to="/">
                <i
                  className="fa fa-long-arrow-left pr-3"
                  aria-hidden="true"
                ></i>
                Go back to Home
              </Link>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(ThankYou);
